import { useEffect, useRef } from 'react';

/**
 * Custom hook that watches for changes in a value and executes a callback when it changes.
 * Skips the initial render to avoid calling the callback on mount.
 *
 * @param {any} value - The value to watch for changes
 * @param {function} callback - The callback to execute when value changes. Receives (newValue, prevValue)
 */
const useWatch = (value, callback) => {
    const prevValue = useRef(value);
    const isFirstRender = useRef(true);

    useEffect(() => {
        const hasChanged = prevValue.current !== value;

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (hasChanged) {
            callback(value, prevValue.current);
        }
        prevValue.current = value;
    }, [value, callback]);
};

export default useWatch;
